// extracted by mini-css-extract-plugin
export default {"locale-switcher":"local-switcher_locale-switcher__4r2SV","locale":"local-switcher_locale__mIMyj","locround":"local-switcher_locround__9FvGG"};